<div class="card">
  <div class="card-header">
    <h2>Welcome to Alpi Tracker CI CD</h2>
    <div class="d-flex flex-row justify-content-between">
      <!--<app-consolidation-filter-panel [filter]="filter" [columns]="columns" (updateFilters)="updateFilters()" (afterClearFilters)="clearFilters()"></app-consolidation-filter-panel>-->
      <app-tracking-tracker-filter-panel [filter]="filter" [columns]="columns" (updateFilters)="updateFilters()" (afterClearFilters)="clearFilters()"></app-tracking-tracker-filter-panel>
    </div>
  </div>
  <div class="card-body" *ngIf="consolList" style="margin-bottom:60px">
    <div class="table-wrapper">
      <app-consolidation-list-table [consolList]="consolList"
                                    [filter]="filter"
                                    [columns]="columns"
                                    [routerlinkPathFn]="routerlinkPathFn"
                                    [NoResultMessage]="NoResultMessage"
                                    [isExtendedColumnsMode]="true"
                                    (clearFilters)="clearFilters()"
                                    (update)="updateConsolList()"
                                    [trackerOnlyColumns]="true">
      </app-consolidation-list-table>
      <ngb-pagination *ngIf="consolList.length"
                      class="d-flex justify-content-center"
                      [collectionSize]="totalCount"
                      [(page)]="currentPage"
                      [pageSize]="pageSize"
                      [rotate]="false"
                      [ellipses]="false"
                      [boundaryLinks]="true"
                      [maxSize]="10"
                      (pageChange)="pageChanged($event)">
        <ng-template ngbPaginationFirst><span class="font-weight-bold">&#x3C;&#x3C;</span> First</ng-template>
        <ng-template ngbPaginationPrevious><span class="font-weight-bold">&#x3C;</span> Prev</ng-template>
        <ng-template ngbPaginationNext>Next <span class="font-weight-bold">&#x3E;</span></ng-template>
        <ng-template ngbPaginationLast>Last <span class="font-weight-bold">&#x3E;&#x3E;</span></ng-template>
        <ng-template ngbPaginationNumber let-p>{{ p }}</ng-template>
      </ngb-pagination>
    </div>
  </div>
</div>
